var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33C8.15789 33 1 25.8421 1 17C1 8.15789 8.15789 1 17 1C25.8421 1 33 8.15789 33 17C33 25.8421 25.8421 33 17 33Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49512 22.3895C10.0109 23.4 11.8635 23.9895 13.8846 23.9895C20.3688 23.9895 24.0741 18.5158 23.8214 13.5474C24.4951 13.0421 25.0846 12.4526 25.5899 11.6947C25.0004 11.9474 24.3267 12.2 23.5688 12.2842C24.3267 11.8631 24.832 11.1895 25.0846 10.3474C24.4109 10.7684 23.653 11.021 22.8951 11.1895C22.2214 10.5158 21.3793 10.0947 20.3688 10.0947C18.0951 10.0947 16.4109 12.2 16.9162 14.3895C13.9688 14.221 11.4425 12.8737 9.67406 10.7684C8.74775 12.3684 9.1688 14.3895 10.7688 15.4842C10.1793 15.4842 9.67406 15.3158 9.1688 15.0631C9.1688 16.6631 10.2635 18.1789 11.9477 18.5158C11.4425 18.6842 10.9372 18.6842 10.3477 18.6C10.7688 20.0316 12.1162 21.0421 13.632 21.0421C12.2004 22.0526 10.3477 22.5579 8.49512 22.3895Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c6b5ef3857856300ed91d2aad4e0d6ea.svg";
export { ForwardRef as ReactComponent };